<template>
  <div class="login-page">
    <div @click="$router.push({name: 'firstLogin'})" class="back-btn cursor-pointer">
      <img src="../../assets/icon/arrow-left.png" class="h-12 w-12" alt="">
      <span class="">戻る</span>
    </div>
    <div class="login-form">
      <div class="logo-login mr-71 inline-block">
          <img src="../../assets/images/parts-logo.png" alt="">
      </div>

      <div class="inline-block">
        <div class="other-way-login mb-20 text-center" :class="loginFormClass">
          <span v-if="loginFormClass === 'patient'">ポケットファーマシーアカウントとしてログインする</span>
          <span v-if="loginFormClass === 'pharmacist'">薬局ポータルアカウントとしてログインする</span>
          <span v-if="loginFormClass === 'other'" >多職種としてログインする</span>
        </div>

        <div class="mb-2 ">
          <input type="text"
                 class="input text no-border w-340 p-15 mb-20"
                 name="account"
                 v-model="formData.account"
                 autofocus
                 autocomplete="off"
                 placeholder="アカウントもしくはメールアドレス"
                 v-validate="'required'"
                 @keyup.enter="login"
                 tabindex="1"
          />
        </div>

        <div class="mb-2 ">
          <input type="password"
                 class="input text no-border w-340 p-15"
                 name="password"
                 placeholder="パスワード"
                 v-model="formData.password"
                 v-validate="'required'"
                 @keyup.enter="login"
                 tabindex="2"
          >
        </div>

        <div class="buttons-flex w-340 mt-35">
          <span @keypress="handleLoginButtonPress($event)"
            @click="login"
            class="flex-1 button"
            tabindex="3"
            :class="{success: loginFormClass === 'pharmacist', info: loginFormClass === 'patient', default: loginFormClass === 'other'}"
          >{{loginBtnText}}</span>
        </div>

        <!-- <div v-if="formData.user_type !== 1" class="button-login mt-25 text-center">
          <a class="forgot-password-link" target="_blank" :href="signupUrl">会員登録はWebで</a>
        </div> -->

        <p class="text-left w-340 mt-20">
          本サービスをご利用になるには、本サービスへの利用規約同意と、電子版お薬手帳サービス「ポケットファーマシー」への同意を行なって頂く必要があります
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import {USER_TYPE_PATIENT, USER_TYPE_PHARMACIST} from '@/const'
import MasterApi from '@/api/master'
import {apiErrorDialog} from '@/helpers'

export default {
  data () {
    return {
      errorModalTitle: '',
      errorModalMessage: '',
      formData: {
        account: '',
        password: '',
        user_type: null
      },
      signupUrl: '',
      loginBtnText: '',
      loginFormClass: ''
    }
  },
  methods: {
    login () {
      this.$validator.validateAll()
        .then((res) => {
          if (res) {
            const loading = this.$loading.show()
            try {
              this.$auth.login({
                data: this.formData,
                fetchUser: false,
                redirect: '/pending-meetings',
                success: (res) => {
                  localStorage.setItem('policy_applied', res.data.policy_applied)
                  this.$auth.token(null, res.data.token)
                  this.$auth.fetch()
                  loading.hide()
                },
                error: (error) => {
                  loading.hide()

                  if (error.response && error.response.status >= 500) {
                    return apiErrorDialog(this, error)
                  }

                  // APIレスポンスから動的にメッセージを取得
                  let errorMessage = 'IDかパスワードが違います' // フォールバック用のデフォルトメッセージ
                  
                  if (error.response && error.response.data) {
                    const errorData = error.response.data
                    
                    // error_codeとmessageを取得
                    const errorCode = errorData.error_code
                    const message = errorData.message
                    
                    // アカウントロック時の特別処理
                    if (errorCode === 'ACCOUNT_LOCKED' && errorData.data) {
                      const remainingMinutes = errorData.data.remaining_minutes
                      if (remainingMinutes && remainingMinutes > 0) {
                        errorMessage = message ? `${message} 残り時間: ${remainingMinutes}分` : `アカウントがロックされています。残り時間: ${remainingMinutes}分`
                      } else {
                        errorMessage = message || 'アカウントがロックされています。'
                      }
                    } else if (message) {
                      // 通常の認証失敗時はmessageフィールドの内容を表示
                      errorMessage = message
                    }
                  }
                  
                  this.$message.error(errorMessage)
                }
              })
            } catch (e) {
              apiErrorDialog(this, e)
            }
          }
        })
    },
    handleLoginButtonPress (e) {
      if (e.keyCode === 13) {
        this.login()
      }
    }
  },
  async mounted () {
    let userType = null
    const res = await MasterApi.get()
      .catch((error) => apiErrorDialog(this, error))
    if (!res) return
    this.loginFormClass = this.$route.params.userType
    switch (this.$route.params.userType) {
      case 'patient':
        userType = USER_TYPE_PATIENT
        this.signupUrl = res.data.data.signup_url
        this.loginBtnText = '患者としてログインする'
        break
      case 'pharmacist':
        userType = USER_TYPE_PHARMACIST
        this.loginBtnText = '薬剤師としてログインする'
        break
      case 'other':
        // userType = USER_TYPE_OTHER
        // this.signupUrl = res.data.data.other_signup_url
        this.loginBtnText = '多職種としてログインする'
        break
    }
    this.formData.user_type = userType
    if (process.env.REMEMBER_USER_TYPE) {
      localStorage.setItem('user_type', userType)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/auth/Login.vue